const NINGI_JOURNEY_STATUS = Object.freeze({
  COMPLETED_NINGI_JOURNEY: 0,
  INCOMPLETED_NINGI_JOURNEY: 1,
});

export default NINGI_JOURNEY_STATUS;
